const ProductHeader = ({ productLength, handleAlphabeticOrder }) => {



  return (
    <div className="d-flex align-items-center mb-3">
      <div className="col-sm mb-3 mb-sm-0">
        <h6 className="mb-0">
          {productLength} product{productLength > 1 ? "s" : ""}{" "}
        </h6>
      </div>
      <div className="col-sm-auto">
        <div className="d-sm-flex justify-content-sm-end align-items-center">
          <div className="mb-2 mb-sm-0 me-sm-2">
            <select className="form-select form-select-sm">
              <option value="Relevance" selected>
                Relevance
              </option>
              <option value="mostRecent">Most recent</option>
            </select>
          </div>
          <div className="mb-2 mb-sm-0 me-sm-2">
            <select
              className="form-select form-select-sm"
              onChange={handleAlphabeticOrder}
            >
              <option value='' selected>
               Alphabetic order
              </option>
              <option value="atoz" >
                A-to-Z
              </option>
              <option value="ztoa">Z-to-A</option>
            </select>
          </div>
          {/* <ul className="nav nav-segment">
            <li className="nav-item">
              <a className="nav-link active" href="../demo-shop/products-grid.html">
                <i className="bi-grid-fill"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="../demo-shop/products-list.html">
                <i className="bi-list"></i>
              </a>
            </li>
          </ul> */}
        </div>
      </div>
    </div>
  );
};

export default ProductHeader;
